import React from 'react'

// Components
import Profile from './Profile'

const NoProfiles = () => <p>There are no profiles.</p>

const ProfileList = ({ profiles, onDeleteClicked }) => {
  if (!profiles || profiles.length === 0) return <NoProfiles />

  return(
    <div className="profile-list">
      { 
        profiles.map(profile =>
          <Profile 
            key={profile.username} 
            profile={profile} 
            onDeleteClicked={onDeleteClicked}
            shortLog={true} 
          />
        )
      } 
    </div>
  )
}

export default ProfileList;



// WEBPACK FOOTER //
// ./src/components/Admin/ProfileList.js